import { defineMessages } from 'react-intl'

export default defineMessages({
  branches: {
    id: 'containers.CustomerOrdersPage.components.Filters.branches',
    defaultMessage: 'Teams',
  },
  contact: {
    id: 'containers.CustomerOrdersPage.components.Filters.contact',
    defaultMessage: 'Producers',
  },
  template: {
    id: 'containers.CustomerOrdersPage.components.Filters.template',
    defaultMessage: 'Tier',
  },
  stage: {
    id: 'containers.CustomerOrdersPage.components.Filters.stage',
    defaultMessage: 'Stage',
  },
})
